import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Milano',
    description:
        'Milano is a boutique fashion house bringing you the right gear for every season. Discover premium, limited clothing and accessories.',
    url: 'https://milano.clothes',
    ogImage: '/images/OGuseAnimationsImage.jpeg'
}
